import { useDeferredValue } from 'react';
import { useDebounce } from '@simplywallst/hooks/useDebounce';

import { useSearchBrokerages } from './useSearchBrokerages';

export const useBrokerSearch = ({ searchInput }: { searchInput: string }) => {
  const deferredInput = useDeferredValue(searchInput);
  const debouncedInput = useDebounce(deferredInput, 500);

  return useSearchBrokerages(
    {
      input: debouncedInput,
      supportedProviders: ['passiv', 'sharesight', 'plaid'],
    },
    {
      enabled: debouncedInput !== '',
    }
  );
};
